import { Outlet, useMatches } from "react-router";

import { useMe } from "../features/auth/session";
import { useUnreadCount } from "../features/claims/queries";
import { useOpenFlags } from "../features/moderation/queries";
import { ReportProvider } from "../features/report/ReportProvider";
import { SearchProvider } from "../features/search/SearchProvider";
import { nl } from "../i18n/nl";
import type { ScreenHandle } from "../routes/screens";
import styles from "./AppShell.module.css";
import { Sidebar } from "./Sidebar";
import { TabBar } from "./TabBar";
import { TopBar } from "./TopBar";

function useScreenTitle(): string {
  const matches = useMatches();
  for (const match of [...matches].reverse()) {
    const handle = match.handle as ScreenHandle | undefined;
    if (handle?.title) return handle.title;
  }
  return nl.app.name;
}

/** Desktop (≥ 1024 px): sidebar + top bar. Mobile: content + tab bar. */
export function AppShell() {
  const title = useScreenTitle();
  const me = useMe();
  const unread = useUnreadCount();
  const isModerator = me.data?.role === "moderator";
  const openFlags = useOpenFlags(isModerator);
  return (
    <ReportProvider>
    <SearchProvider>
    <div className={styles.shell}>
      <a className={styles.skipLink} href="#inhoud">
        {nl.common.skipToContent}
      </a>
      <Sidebar
        className={styles.sidebar}
        isModerator={isModerator}
        unreadCount={unread.data ?? 0}
        openFlagCount={openFlags.data?.length ?? 0}
      />
      <div className={styles.column}>
        <TopBar className={styles.topbar} title={title} />
        <main id="inhoud" className={styles.main} tabIndex={-1}>
          <Outlet />
        </main>
      </div>
      <TabBar unreadCount={unread.data ?? 0} />
    </div>
    </SearchProvider>
    </ReportProvider>
  );
}
